module.exports = __webpack_public_path__ + "img/UGA_tennis_hallFame.7b94a62a.jpg";